export default __webpack_public_path__ + "static/sb_logo-8787addbeb9fce6621d1f15ce9bbb06d.svg";